import {useEffect} from 'react';
import {Navigate, Route, Routes, useLocation} from 'react-router-dom';
import Home from "../pages/Home";
import News from "../pages/News";
import Demos from "../pages/Demos";
import {FAQ} from "../pages/FAQ";
import {ContactUs} from "../pages/ContactUs";
import Privacy from "../pages/Privacy";
import Ventures from "../pages/Ventures";
import Consulting from "../pages/Consulting";
import Leadership from "../pages/Leadership";
import VentureLanding from "../pages/VentureLanding";
import NotFound from "../pages/NotFound";
import {config, ventureRoutes} from "../portalConfig";

// Landing pages are long; without this a click from the footer drops the
// visitor into the middle of the next page.
const ScrollToTop = () => {
    const {pathname} = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};

const RouteSwitcher = () => {
    return (
        <>
            <ScrollToTop/>
            <Routes>
                <Route path="/" element={<Home/>}/>
                <Route path="/home" element={<Home/>}/>

                <Route path="/ventures" element={<Ventures/>}/>
                {config.ventures.map((venture) => (
                    <Route
                        key={venture.slug}
                        path={venture.route}
                        element={<VentureLanding slug={venture.slug}/>}
                    />
                ))}

                <Route path="/leadership" element={<Leadership/>}/>
                <Route path="/consulting" element={<Consulting/>}/>

                <Route path="/news" element={<News/>}/>
                <Route path="/news/:assetId" element={<News/>}/>
                <Route path="/demos" element={<Demos/>}/>
                <Route path="/faq" element={<FAQ/>}/>
                <Route path="/privacy-policy" element={<Privacy/>}/>
                <Route path="/contact-us" element={<ContactUs/>}/>

                {/* Retired routes — keep inbound links alive. */}
                <Route path="/products" element={<Navigate to="/ventures" replace/>}/>
                {config.ventures.map((venture) => (
                    <Route
                        key={`legacy-${venture.slug}`}
                        path={`/products/${venture.slug}`}
                        element={<Navigate to={venture.route} replace/>}
                    />
                ))}
                {/* Renamed venture: Prompt Management -> Enterprise AI Management. */}
                <Route
                    path="/ventures/prompt-management"
                    element={<Navigate to={ventureRoutes.enterpriseAi} replace/>}
                />
                <Route
                    path="/products/prompt-management"
                    element={<Navigate to={ventureRoutes.enterpriseAi} replace/>}
                />
                {/* The archive has no per-item page; old deep links land on the index. */}
                <Route path="/demos/:assetId" element={<Navigate to="/demos" replace/>}/>
                <Route path="/our-team" element={<Navigate to="/leadership" replace/>}/>
                <Route path="/intelligence-consulting" element={<Navigate to="/consulting" replace/>}/>
                <Route path="/feature-and-benefits" element={<Navigate to="/ventures" replace/>}/>
                <Route path="/pricing" element={<Navigate to="/ventures" replace/>}/>
                <Route path="/tasks" element={<Navigate to="/ventures" replace/>}/>
                <Route path="/billing" element={<Navigate to="/ventures" replace/>}/>
                <Route path="/profile" element={<Navigate to="/ventures" replace/>}/>

                <Route path="*" element={<NotFound/>}/>
            </Routes>
        </>
    );
};

export default RouteSwitcher;
